<template>
<div class="clearfix">
    <vForm style="padding: 10px 15px;" v-model="formData" labelWidth="60">
        <vFormItem label="附件模型">
            <vSelect placeholder="请选择" v-model="formData.modelId" @on-change="getTypeList(formData.modelId)">
                <vOption v-for="item in modelList" :key="item.key" :value="item.id">{{item.title}}</vOption>
            </vSelect>
        </vFormItem>
        <vFormItem label="附件类型">
            <vSelect placeholder="请选择" v-model="formData.typeId">
                <vOption v-for="item in typeList" :key="item.key" :value="item.id">{{item.title}}</vOption>
            </vSelect>
        </vFormItem>
        <vFormItem label="环境类型">
            <vSelect v-model="formData.envType">
                <vOption v-for="item in envList" :key="item.key" :value="item.value">{{item.label}}</vOption>
            </vSelect>
        </vFormItem>
    </vForm>
    <div class="pull-right" style="margin-bottom: 10px;">
        <Button @click="submit" type="primary" style="margin-right: 15px;">提交</Button>
        <Button @click="cancel">取消</Button>
    </div>
</div>
</template>
<script>
import { HttpAllAttachmentModel, HttpAttachModelType, HttpAttachClone } from "@/service/ucadm";
export default {
    props: ['id'],
    data () {
        return {
            formData: {
                id: this.id,
                envType: 0
            },
            modelList: [],
            typeList: [],
            envList: [{
                label: '本地（默认）',
                value: 0
            }, {
                label: '开发',
                value: 1
            }, {
                label: '测试',
                value: 2
            }, {
                label: '预发布',
                value: 3
            }, {
                label: '生产',
                value: 4
            }]
        }
    },
    created () {
        // 获取所有模型
        HttpAllAttachmentModel().then(res => {
            this.modelList = res.data
        })
    },
    methods: {
        getTypeList (id) {
            if (!id) return
            this.formData.typeId = null
            HttpAttachModelType({
                modelId: id
            }).then(res => {
                this.typeList = res.data
            })
        },
        cancel () {
            this.$emit('on-close')
        },
        submit () {
            HttpAttachClone({
                ...this.formData
            }).then(res => {
                this.$VMessage.success(res.message)
                this.$emit('on-close')
            }, err => {
                this.$VMessage.error(err.message)
            })
        }
    }
}
</script>